/* ========================================
   CLOTHING BRAND THEME - SCRIPT.JS
   Basic JavaScript Functionality
   ======================================== */

// Bestsellers scroll parallax - global function
function handleBestsellersScroll() {
    const bestsellersScroll = document.getElementById('bestsellers-scroll');
    const bestsellersBg = document.getElementById('bestsellers-bg');
    
    if (bestsellersScroll && bestsellersBg) {
        const scrollLeft = bestsellersScroll.scrollLeft;
        const maxScroll = bestsellersScroll.scrollWidth - bestsellersScroll.clientWidth;
        
        if (maxScroll > 0) {
            const scrollPercent = scrollLeft / maxScroll;
            // Move background - 50% of viewport width
            const maxBgMove = window.innerWidth * 0.5;
            const bgOffset = scrollPercent * maxBgMove;
            
            bestsellersBg.style.transform = 'translateX(-' + bgOffset + 'px)';
        }
    }
}

// Initialize bestsellers scroll when DOM is ready
function initBestsellersScroll() {
    const bestsellersScroll = document.getElementById('bestsellers-scroll');
    if (bestsellersScroll) {
        bestsellersScroll.addEventListener('scroll', handleBestsellersScroll);
        // Also listen for touch events on mobile
        bestsellersScroll.addEventListener('touchmove', handleBestsellersScroll);
    }
}

// Run on page load
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBestsellersScroll);
} else {
    initBestsellersScroll();
}

// Toggle dropdown function for Art/Clothes
function toggleDropdown(id) {
    const dropdown = document.getElementById(id);
    const allDropdowns = document.querySelectorAll('.mega-dropdown');
    
    // Close all other dropdowns
    allDropdowns.forEach(d => {
        if (d.id !== id) {
            d.classList.remove('active');
        }
    });
    
    // Toggle this dropdown
    dropdown.classList.toggle('active');
}

// Toggle navigation menu (hamburger)
function toggleNavMenu() {
    const hamburger = document.getElementById('hamburger-menu');
    const navDropdown = document.getElementById('nav-dropdown');
    
    hamburger.classList.toggle('active');
    navDropdown.classList.toggle('active');
}

// Close dropdowns when clicking outside
document.addEventListener('click', function(e) {
    // Close Art/Clothes dropdowns
    if (!e.target.closest('.mega-dropdown')) {
        const allDropdowns = document.querySelectorAll('.mega-dropdown');
        allDropdowns.forEach(d => d.classList.remove('active'));
    }
    
    // Close nav dropdown
    if (!e.target.closest('.hamburger-menu') && !e.target.closest('.nav-dropdown')) {
        const hamburger = document.getElementById('hamburger-menu');
        const navDropdown = document.getElementById('nav-dropdown');
        if (hamburger && navDropdown) {
            hamburger.classList.remove('active');
            navDropdown.classList.remove('active');
        }
    }
});

document.addEventListener('DOMContentLoaded', function() {

    // ========================================
    // NAVBAR SCROLL EFFECT
    // ========================================
    const navbar = document.querySelector('.navbar');
    
    window.addEventListener('scroll', function() {
        if (window.scrollY > 50) {
            navbar.classList.add('scrolled');
        } else {
            navbar.classList.remove('scrolled');
        }
    });

    // ========================================
    // MOBILE MENU TOGGLE
    // ========================================
    const mobileMenuBtn = document.querySelector('.mobile-menu-btn');
    const navLinks = document.querySelector('.nav-links');
    
    if (mobileMenuBtn) {
        mobileMenuBtn.addEventListener('click', function() {
            this.classList.toggle('active');
            navLinks.classList.toggle('active');
            document.body.classList.toggle('menu-open');
        });
    }

    // ========================================
    // CART FUNCTIONALITY (Demo)
    // ========================================
    const cartCount = document.querySelector('.cart-count');
    const addToCartBtns = document.querySelectorAll('.action-btn');
    let cartItems = 0;

    addToCartBtns.forEach(btn => {
        if (btn.textContent.includes('Add to Cart')) {
            btn.addEventListener('click', function(e) {
                e.preventDefault();
                cartItems++;
                if (cartCount) {
                    cartCount.textContent = cartItems;
                    cartCount.classList.add('bounce');
                    setTimeout(() => cartCount.classList.remove('bounce'), 300);
                }
                
                // Show feedback
                showNotification('Item added to cart!');
            });
        }
    });

    // ========================================
    // NEWSLETTER FORM
    // ========================================
    const newsletterForm = document.querySelector('.newsletter-form');
    
    if (newsletterForm) {
        newsletterForm.addEventListener('submit', function(e) {
            e.preventDefault();
            const email = this.querySelector('input[type="email"]').value;
            
            if (email) {
                showNotification('Thanks for subscribing!');
                this.reset();
            }
        });
    }

    // ========================================
    // CONTACT FORM
    // ========================================
    const contactForm = document.querySelector('.contact-form');
    
    if (contactForm) {
        contactForm.addEventListener('submit', function(e) {
            e.preventDefault();
            showNotification('Message sent! We\'ll get back to you soon.');
            this.reset();
        });
    }

    // ========================================
    // NOTIFICATION SYSTEM
    // ========================================
    function showNotification(message) {
        // Remove existing notification
        const existingNotification = document.querySelector('.notification');
        if (existingNotification) {
            existingNotification.remove();
        }

        // Create notification element
        const notification = document.createElement('div');
        notification.className = 'notification';
        notification.innerHTML = `
            <span>${message}</span>
            <button class="notification-close">&times;</button>
        `;
        
        // Add styles
        notification.style.cssText = `
            position: fixed;
            bottom: 20px;
            right: 20px;
            background: #1a1a1a;
            color: white;
            padding: 16px 24px;
            border-radius: 8px;
            display: flex;
            align-items: center;
            gap: 16px;
            box-shadow: 0 4px 12px rgba(0,0,0,0.15);
            z-index: 9999;
            animation: slideIn 0.3s ease;
        `;

        document.body.appendChild(notification);

        // Close button
        notification.querySelector('.notification-close').addEventListener('click', () => {
            notification.remove();
        });

        // Auto remove after 3 seconds
        setTimeout(() => {
            if (notification.parentNode) {
                notification.style.animation = 'slideOut 0.3s ease';
                setTimeout(() => notification.remove(), 300);
            }
        }, 3000);
    }

    // ========================================
    // SMOOTH SCROLL FOR ANCHOR LINKS
    // ========================================
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            const href = this.getAttribute('href');
            if (href !== '#') {
                e.preventDefault();
                const target = document.querySelector(href);
                if (target) {
                    target.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            }
        });
    });

    // ========================================
    // PRODUCT QUICK VIEW (Demo)
    // ========================================
    const quickViewBtns = document.querySelectorAll('.action-btn');
    
    quickViewBtns.forEach(btn => {
        if (btn.textContent.includes('Quick View')) {
            btn.addEventListener('click', function(e) {
                e.preventDefault();
                showNotification('Quick view feature - coming soon!');
            });
        }
    });

    // ========================================
    // ANIMATION ON SCROLL
    // ========================================
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('fade-in');
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);

    // Observe elements
    document.querySelectorAll('.product-card, .category-card, .value-card').forEach(el => {
        el.style.opacity = '0';
        el.style.transform = 'translateY(20px)';
        el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
        observer.observe(el);
    });

    // Add fade-in class styles
    const style = document.createElement('style');
    style.textContent = `
        .fade-in {
            opacity: 1 !important;
            transform: translateY(0) !important;
        }
        
        .bounce {
            animation: bounce 0.3s ease;
        }
        
        @keyframes bounce {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.2); }
        }
        
        @keyframes slideIn {
            from {
                opacity: 0;
                transform: translateX(100px);
            }
            to {
                opacity: 1;
                transform: translateX(0);
            }
        }
        
        @keyframes slideOut {
            from {
                opacity: 1;
                transform: translateX(0);
            }
            to {
                opacity: 0;
                transform: translateX(100px);
            }
        }
        
        .notification-close {
            background: none;
            border: none;
            color: white;
            font-size: 1.5rem;
            cursor: pointer;
            padding: 0;
            line-height: 1;
        }
        
        /* Mobile menu styles */
        @media (max-width: 768px) {
            .nav-links.active {
                display: flex !important;
                position: fixed;
                top: 70px;
                left: 0;
                right: 0;
                bottom: 0;
                background: white;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                gap: 2rem;
            }
            
            .mobile-menu-btn.active span:nth-child(1) {
                transform: rotate(45deg) translate(5px, 5px);
            }
            
            .mobile-menu-btn.active span:nth-child(2) {
                opacity: 0;
            }
            
            .mobile-menu-btn.active span:nth-child(3) {
                transform: rotate(-45deg) translate(7px, -6px);
            }
            
            body.menu-open {
                overflow: hidden;
            }
        }
    `;
    document.head.appendChild(style);

});
